const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Zа-яА-Я\-0-9]+\.)+[a-zA-Zа-яА-Я]{2,}))$/; // eslint-disable-line

const validate = (values: any) => {
  const errors: any = {};

  if (!values.userEmail) {
    errors.userEmail = 'Обязательное поле';
  } else if (!emailPattern.test(values.userEmail.toLowerCase())) {
    errors.userEmail = 'Неверный формат электронной почты';
  }
  
  if (!values.captcha) {
    errors.captcha = 'Обязательное поле';
  }

  return errors;
};

export default validate;
